/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const PxeProductizationModel = types
  .model('PxeProductizationModel', {
    productId: types.maybeNull(types.string),
    productData: types.maybeNull(types.frozen()),
    isValid: types.maybeNull(types.boolean),
    validationError: types.maybeNull(types.string)
  })
  .actions((self) => ({
    /* eslint-disable no-param-reassign */
    fetch(productId) {
      Framework.getEventManager().publish(constants.PXE_PRODUCTIZATION_FETCHED, { productId });
    },
    set(data) {
      applySnapshot(self, data);
    },
    reset() {
      applySnapshot(self, { productId: null, productData: null, isValid: null, validationError: '' });
    }
  }));

export default PxeProductizationModel;
